module.exports = __webpack_public_path__ + "img/342.c9ece139.jpg";